import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NewsAuthGuard } from './news/guards/auth.guard';
import { Role } from './shared/enums/role.enum';
import { Auth2Guard } from './shared/guards/auth/auth2.guard';
import { IsRoleGuard } from './shared/guards/auth/is-role.guard';
import { RoleRedirectorGuard } from './shared/guards/auth/role-redirector.guard';

const routes: Routes = [
  {
    path: 'debug',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
  },
  {
    path: '',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    canActivate: [Auth2Guard, RoleRedirectorGuard],
  },
  {
    path: 'welcome',
    loadChildren: () => import('./welcome/welcome.module').then(m => m.WelcomeModule),
    canActivate: [Auth2Guard, IsRoleGuard],
    data: {
      roles: [Role.User],
    },
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [Auth2Guard, IsRoleGuard],
    data: {
      roles: [Role.Admin, Role.HRManager, Role.HRTeam, Role.Medical, Role.Finance, Role.Safety, Role.CrewAdminManager],
    },
  },
  {
    path: 'faq',
    loadChildren: () => import('./faq/faq.module').then(m => m.FaqModule),
    canActivate: [Auth2Guard],
  },
  {
    path: 'error',
    loadChildren: () => import('./error/error.module').then(m => m.ErrorModule),
  },
  {
    path: 'comp-room',
    loadChildren: () => import('./comp-room/comp-room.module').then(m => m.CompRoomModule),
  },
  {
    path: 'news',
    loadChildren: () => import('./news/news.module').then(m => m.NewsModule),
    canActivate: [NewsAuthGuard],
  },
  {
    path: 'stepper',
    loadChildren: () => import('./check-in/check-in.module').then(m => m.CheckInModule),
    canActivate: [Auth2Guard, IsRoleGuard],
    data: {
      roles: [Role.User],
      paramRegex: [['type', /(check-in|check-out)/g]],
    },
  },
  {
    path: '**',
    redirectTo: 'error',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
